import { render, staticRenderFns } from "./OtherResourcesDetails.vue?vue&type=template&id=221966fc&scoped=true"
import script from "./OtherResourcesDetails.vue?vue&type=script&lang=js"
export * from "./OtherResourcesDetails.vue?vue&type=script&lang=js"
import style0 from "./OtherResourcesDetails.vue?vue&type=style&index=0&id=221966fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221966fc",
  null
  
)

export default component.exports